import { userLabel } from "../../lib/personLabel";
import type { MentionDirectory } from "./MentionDirectoryContext";

/** The fields of a user-directory record a chip needs. */
export interface MentionDirectoryUser {
  displayName: string;
  profileName?: string | null;
  label?: string;
  isActive: boolean;
}

/**
 * The directory every chip under the shell resolves against (SA-04 §5). The name is `userLabel`, the same rule the
 * assignee, reporter and author lines use ("Profile name (Real name)", else the real name), in every locale: a chip
 * never switches to `displayNameTh` (GRF-61).
 */
export function mentionDirectoryOf(byId: ReadonlyMap<number, MentionDirectoryUser>, selfId: string | null): MentionDirectory {
  return {
    resolve: (id) => {
      // Ids are bigint on the wire; anything a JavaScript number cannot hold exactly is simply not in the map.
      if (!/^[0-9]{1,15}$/.test(id)) return null;
      const user = byId.get(Number(id));
      if (!user) return null;
      return { name: userLabel(user), active: user.isActive };
    },
    selfId,
  };
}
